<template>
  <div class="body-bg-white">
    <SPreloader />
    <SSubHeader :pageName="'Item details'" :backButton="true" />
    <div class="header-spacer"></div>
    <md-content class="page-content">
      <md-content class="center-content">

        <div class="content-wrapper">
          <div class="content-above">
            <!-- Item Image -->
            <div class="image-of-item">
              <div class="item-image-wrapper" :class="[
                {'item-unavailable': !isItemAvailable},
                getTradeBorder
              ]">
                <div class="item-trade-type" :class="[getBackgroundColor]">
                  <span class="item-trade-type-text">{{ posterName }} {{ wantText }} <strong>{{  getTradeType }}</strong></span>
                </div>
                <div class="image-wrapper">
                  <img
                    :src="getItemImagePath(itemProfile)"
                    alt="product"
                    class="main-img"
                    style="background: white"
                    @click="openFullImage()"
                  />
                  <LoadingSpinner
                      position="absolute"
                      v-if="pageLoading === true"
                  />
                </div>
                <md-tooltip md-direction="bottom">Open full image</md-tooltip>
              </div>
            </div>
            <!-- Info about item -->
            <div class="item-informations--wrapper">
              <div class="info-content">
                <div class="info-content-header">
                  <div class="info-content-header-user">
                      <div class="info-item-category">
                      <span class="item-category-title">
                          {{ itemCategoryProfile }}
                      </span>
                      </div>
                      <div class="info-item-avatar">
                      <div class="info-avatar">
                          <router-link :to="`/s-app/profile-page/${this.user.id}`">
                          <SUserAvatar
                              :myUser="this.user"
                              size="small"
                              :isProfileAvatar="true"
                          />
                          </router-link>
                      </div>
                      <div class="info-username">
                          <router-link class="profile-poster-link" :to="`/s-app/profile-page/${user.id}`">
                              {{ this.getUserName(this.user) }}
                          </router-link>
                          <span class="profile-poster-username">@{{ this.user.username }}</span>
                      </div>
                      </div>
                      <div class="info-item-date">
                        <span class="info-date">Posted <strong>{{ itemProfile.createdAt | relativeDate }}</strong></span>
                      </div>
                  </div>
                  <div>
                    <div class="info-content-header-button" v-if="isItemFromUser">
                        <DotItemMenu
                        :showEditMenu="
                            (isItemFromUser && editButtomAvailable(itemProfile))
                        "
                        :itemId="itemProfile.id"
                        :showDeleteRequest="showDeleteOption"
                        :item="itemProfile"
                        :isMenuRight="true"
                        @delete-item="openDeleteModal()"
                        />
                    </div>
                    <div class="wishlist-button" v-else>
                      <SButtonMaterial v-if="!isItemOnWishlist"
                        class="send-msg-item-btn"
                        buttonType="button"
                        :color="getTradeColor"
                        textColor="white"
                        materialClass="dense"
                        iconWithoutText="favorite"
                        iconColor="white"
                        @button="setFavoriteItem()"
                        data-cy="headerWishlistButton"
                      />
                      <SButtonMaterial v-else
                        class="send-msg-item-btn"
                        buttonType="button"
                        color="white"
                        textColor="white"
                        materialClass="dense"
                        iconWithoutText="favorite"
                        :iconColor="getTradeColor"
                        :borderColor="getTradeColor"
                        @button="setFavoriteItem()"
                        data-cy="headerWishlistButton"
                      />
                    </div>
                  </div>
                </div>

                <div class="info-content-divider" />

                <div class="info-content-main">
                  <h3 class="info-content-title" data-cy="itemDetailsTitle">
                      {{ itemProfile.title }}
                  </h3>

                  <p class="info-content-condition">
                      Condition: <strong>{{ getItemCondition(itemProfile) }}</strong>
                  </p>

                  <div class="info-content-price">
                    <span class="price" v-if="isItemFree">Free</span>

                    <div class="content-price" v-else>
                    <div v-if="itemProfile.points > 0 && itemProfile.cash <= 0">
                        <span class="price">
                        {{ getItemPoints.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                        <img
                            src="/img/Polygon_7.svg"
                            alt="Swampum"
                            width="12"
                            height="12"
                        />
                        </span>
                    </div>
                    <div v-else-if="itemProfile.cash > 0 && itemProfile.points <= 0">
                        <span class="price" v-if="itemProfile.cash > 0">
                        {{ getItemCash | toCurrency }}
                        </span>
                    </div>
                    <div v-else>
                        <span class="price">
                        {{ getItemCash | toCurrency }}
                        </span>
                        or
                        <span class="price">
                        {{
                            getItemPoints
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <img
                            class="price-image-points"
                            src="/img/Polygon_7.svg"
                            alt="Swampum"
                        />
                        </span>
                    </div>
                    </div>
                  </div>

                  <p class="info-content-description" data-cy="itemDetailsDescription" v-linkified v-html="getDescriptionItem" />
                </div>

                <div class="info-content-actions">
                  <!-- Actions Case 1 -->
                  <div class="user-item-actions" v-if="!isItemFromUser && isItemAvailable && !userHasRequest">
                    <div class="mr-2 request-btn-size">
                      <SButtonMaterial
                        class="trade-item-btn"
                        buttonType="button"
                        textColor="white"
                        iconColor="white"
                        iconLeftText="swap_horiz"
                        materialClass="dense"
                        :color="getTradeColor"
                        :class="[
                          { 'offer-item-class': getTradeText === 'offer' },
                        ]"
                        :text="getTradeText"
                        @button="openTrade()"
                        :data-cy="`itemTradeBtn-${itemProfile.title}`"
                      />
                    </div>
                    <div class="chat-btn-size">
                      <SButtonMaterial
                        class="send-msg-item-btn"
                        :md-ripple="false"
                        buttonType="button"
                        textColor="white"
                        :iconColor="getTradeColor"
                        iconWithoutText="chat"
                        materialClass="dense"
                        @button="openChat(itemProfile)"
                      />
                    </div>
                  </div>

                  <!-- Actions Case 2 -->
                  <div class="user-item-actions" v-else-if="!isItemFromUser && (userHasRequest || !userHasRequest) && (!isItemAvailable && isItemLendOrBorrow) && isRequestRejectedByOwner">
                    <div class="mr-2 request-btn-size">
                      <SButtonMaterial
                        class="trade-item-btn"
                        buttonType="button"
                        textColor="white"
                        iconColor="white"
                        iconLeftText="hourglass_bottom"
                        materialClass="dense"
                        color="tertiary"
                        :disabled="!isItemAvailable"
                        text="Currently Unavailable"
                        @button="openTrade()"
                        :data-cy="`itemTradeBtn-${itemProfile.title}`"
                      />
                    </div>
                    <div class="chat-btn-size">
                      <SButtonMaterial
                        class="send-msg-item-btn"
                        :md-ripple="false"
                        buttonType="button"
                        textColor="white"
                        :iconColor="getTradeColor"
                        iconWithoutText="chat"
                        materialClass="dense"
                        @button="openChat(itemProfile)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Where is Located -->
          <!-- <div class="content-middle">
            <h3 class="map-item--title">Where is Located</h3>
            <div id="mapContainer" class="content-middle--mapContainer"></div>
          </div> -->
          <!-- Items May You Like -->
          <div class="content-below" v-if="!isItemFromUser">
            <h3 class="content-below--title">Other items you may like:</h3>

            <div class="items-may-you-like--wrapper">
              <div
                v-for="(result, index) in itemsMayYouLike"
                :key="index"
              >
                <SNewItemMaterial
                  :item="result"
                />
              </div>
            </div>
          </div>
        </div>

        <ModalTradeItem
          v-if="isUserAuthenticated"
          :item="itemProfileModal"
          ref="modalTradeItem"
        />
        <div v-if="isItemFromUser">
          <SItemRequestsMenu
            v-if="pageLoading === false"
            ref="itemRequestsMenu"
            :itemRequests="requests"
            :requestFromUser="false"
            :itemHaveRequests="itemHaveRequests"
            :itemHaveDeclinedRequests="itemHaveDeclinedRequests"
            :cash="itemProfile.cash"
            :points="itemProfile.points"
            :requestsText="requestNumberText"
            :requestIcon="getIconName"
            :mainColor="getMainColor"
            :item="itemWithRequests"
            @accept-request="$emit('accept-request')"
            @accept-offer="$emit('accept-offer')"
          />
        </div>
        <div v-if="!isItemFromUser && userHasRequest">
          <SItemRequestsMenu
            v-if="pageLoading === false"
            ref="itemRequestUser"
            :itemRequests="userRequest"
            :requestFromUser="true"
            :itemHaveRequests="itemHaveRequests"
            :itemHaveDeclinedRequests="itemHaveDeclinedRequests"
            :cash="itemProfile.cash"
            :points="itemProfile.points"
            :requestsText="requestNumberText"
            :requestIcon="getIconName"
            :mainColor="getMainColor"
            :item="itemWithRequestsFromUser"
          />
        </div>
      </md-content>
    </md-content>
    <Footer />
    <Modal
      id="accept"
      buttonName="OK"
      :title="modalTitle"
      ref="accept"
      @button="mainAction('accept')"
      :materialButton="true"
      data-cy="modalAcceptTrade"
    >
      <div class="accept-content-modal">
        <ResponsabilityTerms
          @check="setChecked"
          v-if="state === 'WAITING_CHECK'"
          :checkBox="checkTerms"
          :itemType="termItemType"
          :posterId="termPosterId"
          data-cy="termsAcceptTrade"
        />
        <div class="font-weight-bold" v-else>
          <div
            v-if="!fetching"
            data-cy="modalResponseRequest"
            style="color: black"
          >
            {{ responseRequest }}
          </div>
          <div v-else class="text-primary" role="status">
            <LoadingSpinner position="relative" />
          </div>
        </div>
      </div>
    </Modal>
    <Modal
      id="decline"
      buttonName="OK"
      ref="decline"
      title="Decline Request"
      @button="closeModal('decline')"
      class="font-weight-bold"
    >
      <div>
        <div v-if="!fetching" style="color: black">{{ responseRequest }}</div>
        <div v-else class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </Modal>
    <ModalDeleteItem
      :item="itemWithRequests"
      :itemHaveRequests="itemHaveRequests"
      @deleteItem="newsFeedRedirect()"
    />
    <FullSizeImage
      ref="fullSizeImage"
      :images="[getItemImagePath(itemProfile)]"
    />
  </div>
</template>
<script>
import ItemHelper from "@/mixins/ItemHelper";
import itemType from "@/enum/item-type";
import ModalTradeItem from "../molecules/ModalTradeItem.vue";
import Modal from "@/components/atoms/Modal";
import linkify from "vue-linkify";
import requestSituation from "@/enum/request-situation";
import itemStatus from "@/enum/item-status";
import { mapGetters } from "vuex";
import UserHelperVue from "../../mixins/UserHelper.vue";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import Vue from "vue";
import ResponsabilityTerms from "@/components/molecules/ResponsabilityTerms";
import SPreloader from "@/components/organisms/SPreloader.vue";
import PointsHelperVue from "../../mixins/PointsHelper.vue";
import store from "@/vuex/store";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import DotItemMenu from "@/material-components/molecules/DotItemMenu.vue";
import ModalDeleteItem from "@/material-components/molecules/ModalDeleteItem.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import FullSizeImage from "@/material-components/molecules/FullSizeImage.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import SItemRequestsMenu from "@/material-components/organisms/SItemRequestsMenu.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import Footer from "@/templates/Footer";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial";
import axios from 'axios';
import Global from '../../constants/Global';
import L from 'leaflet'

Vue.directive("linkified", linkify);

const headers = {
  'Content-Type': 'application/json'
};

export default {
  name: "SItemDetail",
  mixins: [ItemHelper, UserHelperVue, ChatHelperVue, PointsHelperVue],
  components: {
    ModalTradeItem,
    Modal,
    ResponsabilityTerms,
    SPreloader,
    SSubHeader,
    DotItemMenu,
    ModalDeleteItem,
    SButtonMaterial,
    FullSizeImage,
    LoadingSpinner,
    SItemRequestsMenu,
    SUserAvatar,
    Footer,
    SNewItemMaterial,
  },
  data() {
    return {
      responseRequest: null,
      loggedUserId: null,
      fetching: false,
      isOpen: false,
      userRequest: null,
      reqSituation: requestSituation,
      checkTerms: false,
      state: "WAITING_CHECK",
      posterName: "",
      posterUsername: "",
      pageLoading: true,
      selectedKeyChat: {},
      prevRoute: null,
      // Where is located
      location: {
        lat: 0,
        lng: 0
      },
      // Items may you like
      itemsMayYouLike: [],
      isItemOnWishlist: null,
    };
  },
  methods: {
    getPosterName() {
      if (this.user) {
        this.posterName = this.isItemFromUser
          ? "You"
          : this.getUserName(this.user);
      }
    },
    getPosterUsername() {
      if (this.user) {
        this.posterUsername = this.isItemFromUser ? "You" : this.user.username;
      }
    },
    newsFeedRedirect() {
      this.$router.push("/s-app/feed");
    },
    showDeleteOption() {
      return (
        this.isItemFromUser &&
        (this.getItemAvailability(this.itemProfile) || !this.itemHaveRequests)
      );
    },
    setChecked(c) {
      this.checkTerms = c;
    },
    openDeleteModal() {
      $(`#delete-item-${this.itemProfile.id}`).modal("show");
    },
    openTradeModal() {
      // Due to the way promises are implemented, it wasn't possible to use await
      if (this.isUserAuthenticated && this.isItemAvailable) {
        $(`#trade-item-${this.itemProfile.id}`).modal("show");
      } else {
        setTimeout(this.openTradeModal, 250);
      }
    },
    async setFavoriteItem() {
      if (this.isItemOnWishlist) {
        this.isItemOnWishlist = !this.isItemOnWishlist;
        this.isItemOnWishlist = await axios.delete(Global.getServerDomain() + '/wishlist', { params: this.wishlistObject }, { headers });         
      } else {
        this.isItemOnWishlist = !this.isItemOnWishlist;
        await axios.post(Global.getServerDomain() + '/wishlist', this.wishlistObject, { headers })
      }
    },
    openChat(key) {
      const selectedKeyId = key.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        key.feedType = "NEW_ITEM";
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
        this.selectedKeyChat.messages = this.selectedKeyChat.messages.filter(
          (msg) => {
            return (
              msg.senderId === key.user.id || msg.receiverId === key.user.id
            );
          }
        );
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$refs.rightStickyBar.openClosePopup();
    },
    openTrade() {
      if (this.isUserAuthenticated) {
        $(`#${this.tradeItemModalId}`).modal("show");
      } else {
        const searchQuery = this.getQuery || this.itemProfile.title;
        this.$route.path !==
          `/s-app/search-result/${searchQuery}?sendTradeMessage=${this.itemProfile.id}` &&
          this.$router.push(
            `/s-app/search-result/${searchQuery}?sendTradeMessage=${this.itemProfile.id}`
          );
      }
    },
    async setupItemPage() {
      this.fetchItemMessages(this.$route.params.id);
      await this.fetchItemProfile(this.$route.params.id);
      await this.fetchUserProfile(this.itemProfile.posterId);
      this.fetchItemRequestReceived();
      this.fetchUserInventory(localStorage.getItem("user_id"));
      if (this.$route.query.sendTradeMessage) {
        $(() => {
          this.openTradeModal();
        });
      }
      this.getPosterName();
      this.getPosterUsername();
    },
    mainAction(action) {

      switch (this.state) {
        case "WAITING_CHECK":
          if (this.checkTerms) {
            this.state = "TERMS_CHECKED";
            if (action.includes("accept")) {
               this.accept(this.interestedItem);
            }
          } else {
            this.closeModal(action);
          }
          break;
        case "TERMS_CHECKED":
          this.closeModal(action);
          break;
        default:
          break;
      }
    },
    setNotification(item) {
      let type = item.type;
      if (type === itemType.GIVE || type === itemType.LEND) {
        this.acceptNotification = `Hi, I accepted your request for the item ${item.title}`;
        this.acceptType = "ACCEPT_REQUEST";
        this.declineNotification = `Hi, I didn't accept your request for the item ${item.title}`;
        this.declineType = "DECLINE_REQUEST";
      } else if (type === itemType.RECEIVE || type === itemType.BORROW) {
        this.acceptNotification = `Hi, I accepted your offer for the item ${item.title}`;
        this.acceptType = "ACCEPT_OFFER";
        this.declineNotification = `Hi, I didn't accept your offer for the item ${item.title}`;
        this.declineType = "DECLINE_OFFER";
      }
    },
    async rejectEveryOtherRequest(acceptedRequest) {
      this.interestedItem.requests.forEach(async (r) => {
        if (acceptedRequest.itemId === r.itemId) {
          if (
            acceptedRequest.id !== r.id &&
            r.situation === this.reqSituation.OPEN
          ) {
            try {
              await this.declineItemRequest({ request: r });
            } catch (error) {
              console.log(error);
            }
          }
        }
        this.$refs.itemRequestsMenu.setAllRequestsAsRejected();
      });
    },
    setRequestResponse(conditional, item, paymentMethod, transferResult) {
      if (conditional) {
        if (item === itemType.GIVE || item === itemType.LEND) {
          this.responseRequest = "Request accepted.";
        } else {
          this.responseRequest = "Offer accepted.";
        }
      } else {
        if (paymentMethod === "money")
          this.responseRequest = "Something went wrong!";
        else {
          if (transferResult === "Available point balance is not enough") {
            this.responseRequest = transferResult;
          } else {
            this.responseRequest = "Something went wrong!";
          }
        }
      }
    },
    async accept(item) {
      this.setNotification(item);
      this.fetching = true;
      let response = null;
      let pointsReceiverId = null;
      let pointsGiverId = null;
      let valuePoints = item.points || item.cash;
      let note = null;
      let transfer = null;
      let payWith = null;
      try {
        let request = item.requests.find(
          (request) => this.interestedItem.requestId === request.id
        );
        payWith = request.payWith;
        if (payWith == "money" || payWith === null) {
          response = await this.acceptItemRequest({ request: request });
          let updatedItemStatus = item;
          updatedItemStatus.status = itemStatus.WAITING;
          this.$refs.itemRequestsMenu.setRequestAsAccepted(request.id);
          await this.updateItemStatus({ item: updatedItemStatus });
          await this.postUserItemMessage({
            partner: request.sUserId,
            item: this.itemProfile.id,
            postMsg: this.acceptNotification,
            newChat: true,
          });
          await this.rejectEveryOtherRequest(request);
        } else {

          if (item.type === itemType.GIVE || item.type === itemType.LEND) {
            pointsReceiverId = request.itemId;
            pointsGiverId = request.sUser.id;
          } else {
            pointsReceiverId = request.sUserId;
            pointsGiverId = request.item.posterId;
          }
          note = `trade accepted for the item <a href="/s-app/item-details/${item.id}">${item.title}</a>`;
          transfer = await this.transferPoint({
            to_id: pointsReceiverId,
            from_id: pointsGiverId,
            value: valuePoints,
            note: note,
          });
          if (transfer.result !== "Available point balance is not enough") {
            response = await this.acceptItemRequest({ request: request });
            let updatedItemStatus = item;
            updatedItemStatus.status = itemStatus.WAITING;
            this.$refs.itemRequestsMenu.setRequestAsAccepted(request.id);
            await this.updateItemStatus({ item: updatedItemStatus });
            await this.postUserItemMessage({
              partner: request.sUserId,
              item: this.itemProfile.id,
              postMsg: this.acceptNotification,
              newChat: true,
            });
            await this.rejectEveryOtherRequest(request);
          }
        }
        await this.fetchItemProfile(this.$route.params.id);
        this.fetching = false;
        this.setRequestResponse(
          response === 200,
          item.type,
          payWith,
          transfer?.result || "");
      } catch (error) {
        console.log(error);
      }
    },
    closeModal(modalId) {
      $(`#${modalId}`).modal("hide");
      this.responseRequest = "";
      this.state = "WAITING_CHECK";
      this.checkTerms = false;
    },
    openFullImage() {
      this.$refs.fullSizeImage.openDialog();
    },
    getUserRequest(request) {
      this.userRequest = request;
      this.userRequest.sUser = this.loggedUser;
    },
  },
  computed: {
    ...mapGetters({
      itemMessages: "getItemMessages",
      isUserAuthenticated: "isUserAuthenticated",
      currentUser: "getUser",
    }),
    itemWithRequests() {
      const getRequests = this.itemRequestsReceived.filter(
        (ir) => ir.itemId === this.itemProfile.id
      );
      let iRequests = {
        ...this.itemProfile,
        requests: getRequests,
      };
      return iRequests;
    },
    itemWithRequestsFromUser() {
      const getRequests = this.itemRequestsReceived
      let iRequests = {
        ...this.itemProfile,
        requests: getRequests,
      };
      return iRequests;
    },
    itemHaveRequests() {
      return this.numberOfRequestsOpen !== 0;
    },
    itemHaveDeclinedRequests() {
      return this.numberOfDeclinedRequests !=0;
    },
    itemCategoryProfile() {
      if (
        this.itemProfile !== undefined &&
        this.itemProfile.category !== undefined
      )
        return this.getItemCategory(this.itemProfile);
      return "";
    },
    tradeItemModalId() {
      return `trade-item-${this.itemProfile.id}`;
    },
    isItemFromUser() {
      const userId = this.loggedUser && this.loggedUser.id;
      return this.itemProfile.posterId === userId;
    },
    tradeButtonTooltip() {
      if (this.itemProfile.type !== undefined) {
        const type = this.itemProfile.type;
        if (type === 1 || type === 3) return "Request from this poster";
        else if (type === 2 || type === 4) return "Offer to this poster";
      }
      return "Trade item";
    },
    popupText() {
      return "Send a message to the poster";
    },
    messages() {
      if (this.itemMessages) {
        let arr = this.itemMessages.slice().reverse();
        return arr;
      } else {
        return [];
      }
    },
    userMsgs() {
      if (this.userMessages.length > 0) {
        return this.userMessages.find((item) => {
          return item.id == this.$route.params.id;
        });
      }
      return false;
    },
    isItemAvailable() {
      return itemStatus.IDLE === this.itemProfile.status;
    },
    isItemLendOrBorrow() {
      if(this.itemProfile.type === 4) {
          return this.itemProfile.type === itemType.BORROW
      }
      return this.itemProfile.type === itemType.LEND
    },
    isRequestRejectedByOwner () {
      if(this.userRequest === null) {
        return true
      }
      return this.userRequest.situation === requestSituation.REJECTED
    },
    modalTitle() {
      if (
        itemType.GIVE === this.termItemType ||
        itemType.LEND === this.termItemType
      ) {
        return "Accept request";
      } else {
        return "Accept offer";
      }
    },
    termItemType() {
      return this.interestedItem.type;
    },
    termPosterId() {
      return this.interestedItem.posterId;
    },
    mountRequests() {
      let requests = [];

      for (const request of this.userInventoryWithRequests) {
        if (request.id === this.itemProfile.id) {
          requests = [...request.requests];
        }
      }
      return requests;
    },
    requests() {
      let requests = this.mountRequests;

      let usersId = [];
      let requestsToShow = [];
      requests.forEach((request) => {
        if (usersId.includes(request.sUserId)) {
          const index = requestsToShow.findIndex(
            (req) => req.sUserId === request.sUserId
          );
          let requestDate;
          let currentRequestDate;
          if (requestsToShow[index].updatedAt) {
            requestDate = requestsToShow[index].updatedAt;
          } else {
            requestDate = requestsToShow[index].createdAt;
          }
          if (request.updatedAt) {
            currentRequestDate = request.updatedAt;
          } else {
            currentRequestDate = request.createdAt;
          }
          if (currentRequestDate >= requestDate) {
            requestsToShow.splice(index, 1);
            requestsToShow.push(request);
          }
        } else {
          usersId.push(request.sUserId);
          requestsToShow.push(request);
        }
      });
      return requestsToShow;
    },
    userHasRequest() {
      let reqsFromUser = 0;
      if (
        this.itemProfile === null ||
        this.itemProfile === undefined ||
        this.itemProfile.requests === null ||
        this.itemProfile.requests === undefined
      ) {
        return 0;
      }
      this.itemProfile.requests.forEach((request) => {
        if (request.sUserId === this.loggedUser.id) {
          reqsFromUser++;
          this.getUserRequest(request);
        }
      });

      return reqsFromUser;
    },
    numberOfRequestsOpen() {
      let reqsOpen = 0;
      if (
        this.itemProfile === null ||
        this.itemProfile === undefined ||
        this.itemProfile.requests === null ||
        this.itemProfile.requests === undefined
      ) {
        return 0;
      }
      this.itemProfile.requests.forEach((request) => {
        if (request.situation === this.reqSituation.OPEN) reqsOpen++;
      });

      return reqsOpen;
    },
    numberOfDeclinedRequests() {
      let declinedReqs = 0;
      if (
        this.itemProfile === null ||
        this.itemProfile === undefined ||
        this.itemProfile.requests === null ||
        this.itemProfile.requests === undefined
      ) {
        return 0;
      }
      this.itemProfile.requests.forEach((request) => {
        if (request.situation === this.reqSituation.REJECTED) declinedReqs++;
      });

      return declinedReqs;
    },
    getCategoryIcon() {
      return this.getItemCategoryIconPath(this.itemProfile);
    },
    itemProfileModal() {
      const obj = this.itemProfile;
      obj.user = this.user;

      return obj;
    },
    getPosterText() {
      return this.isItemFromUser ? "You" : this.user.username;
    },
    getTradeColor() {
      return itemType.GIVE === this.itemProfile.type ||
        itemType.LEND === this.itemProfile.type
        ? "tertiary"
        : "offer";
    },
    getLinkColor() {
      let type = this.itemProfile.type;
      return type === itemType.GIVE || type === itemType.LEND
        ? "link-tertiary"
        : "link-offer";
    },
    isItemFree() {
      return this.itemProfile.cash === 0 && this.itemProfile.points === 0;
    },
    getItemCash() {
      if (this.itemProfile.cash > 0) return this.itemProfile.cash;
      return "";
    },
    getItemPoints() {
      if (this.itemProfile.points > 0) return `${this.itemProfile.points}`;
      return "";
    },
    getTradeBorder() {
      let type = this.itemProfile.type;
      if (!this.isItemAvailable) return "border-image-unavailable";
      return type === itemType.GIVE || type === itemType.LEND
        ? "border-image-tertiary"
        : "border-image-offer";
    },
    getBackgroundColor() {
      let type = this.itemProfile.type;
      if (!this.isItemAvailable) return "background-item-unavailable";
      return type === itemType.GIVE || type === itemType.LEND
        ? "trade-type-tertiary"
        : "trade-type-offer";
    },
    wantText() {
      return this.isItemFromUser ? "want to" : "wants to";
    },
    getTradeType() {
      if (this.itemProfile.type === itemType.GIVE) {
        return "GIVE";
      } else if (this.itemProfile.type === itemType.RECEIVE) {
        return "RECEIVE";
      } else if (this.itemProfile.type === itemType.LEND) {
        return "LEND";
      } else {
        return "BORROW";
      }
    },
    /* getPosterName() {
      if(this.user) {
        const posterName = this.isItemFromUser ? "You" : this.getUserName(this.user);
        return posterName;
      }
      return '';
    }, */
    getInterestedColor() {
      if (this.itemHaveRequests) return this.getTradeColor;
      return "disabled";
    },
    getMainColor() {
      if (this.itemHaveRequests) return "primary";
      return "disabled";
    },
    requestNumberText() {
      if (this.numberOfRequestsOpen.toString() === "1")
        return this.numberOfRequestsOpen.toString() + " Request";
      else
        return this.numberOfRequestsOpen.toString() + " Requests";
    },
    getTradeText() {
      return itemType.GIVE === this.itemProfile.type ||
        itemType.LEND === this.itemProfile.type
        ? "Request"
        : "Offer";
    },
    getIconName() {
      return this.itemHaveRequests ? "mood" : "mood_bad";
    },
    getDescriptionItem() {
      let descriptionItem = this.itemProfile.description;
      return descriptionItem;
    },
    wishlistObject(){
      return {
        userId: this.loggedUserId,
        itemId: this.itemProfile.id,
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.params !== from.params) this.setupItemPage();
    },
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchItemProfile", to.params.id);
    const itemValidation = store.getters["getItemProfile"];
    if (!itemValidation.error) {
      next((vm) => {
        vm.prevRoute = from;
      });
    } else {
      next("/s-app/feed");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.modalTradeItem.destroyModal();
    next();
  },
  beforeRouteUpdate(to) {
    this.$refs.modalTradeItem.destroyModal();
    this.$router.push({
      path: `/redirect?type=item-detail&item=${to.params.id}`,
    });
  },
  async created() {
    let userIdString = localStorage.getItem("user_id");
    this.loggedUserId = parseInt(userIdString);
    
    this.setupItemPage();
    document.addEventListener("click", (event) => {
      if (
        !$(event.target).closest(".modal-content").length &&
        $("#accept").is(":visible")
      ) {
        this.closeModal();
      }
    });

    /*
      Find out if the item is already wishlisted by the user
    */
    this.isItemOnWishlist = await axios.get(Global.getServerDomain() + '/wishlistStatus', { params: this.wishlistObject }, { headers }).then(response => {return response.data});

   /*
    Get geolocation
    No futuro utilizar a api do google (Geocoding) para passar o zipcode e utilizar as coordenadas no mapa
   */
    if(navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.location.lat = position.coords.latitude
        this.location.lng = position.coords.longitude

        const map = L.map("mapContainer").setView([this.location.lat, this.location.lng], 15)

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            // attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map)

        L.marker([this.location.lat, this.location.lng]).addTo(map)
      })
    }


    // Items may you like
    let categoryName = '';
    switch (this.itemProfile.category) {
      case 1:
        categoryName = 'HouseHold'
        break;
      case 2:
        categoryName = 'Electronics'
        break;
      case 3:
        categoryName = 'Clothing'
        break;
      case 4:
        categoryName = 'Music'
        break;
      case 5:
        categoryName = "Auto"
        break;
      case 6:
        categoryName = "Video"
        break;
      case 7:
        categoryName = "Other"
        break;
      case 8:
        categoryName = "Book"
        break;
      case 9:
        categoryName = "Family"
        break;
      case 10:
        categoryName = "Games"
        break;
      case 11:
        categoryName = "Sports"
        break;
      case 12:
        categoryName = "Tools"
        break;
      case 13:
        categoryName = "Free"
        break;
      default:
        break;
    }

    let result = await axios.get(Global.getServerDomain() + '/bookmark?query='+categoryName, { headers }).then(response => { return response.data })

    const itemID = Number(this.$route.params.id)
    const currentUserID = this.currentUser.id

    this.itemsMayYouLike =
      result.filter(item => { if(item.id !== itemID) return item })
        .filter(item => { if(item.user.id !== currentUserID) return item })
          .slice(0,4)
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ trigger: "hover" });
    if (this.prevRoute.path === "/s-app/feed") {
      this.$router.go();
    }
    setTimeout(() => {
      this.pageLoading = false;
    }, 1000);
  },
};
</script>
<style scoped>
.item-unavailable {
  filter: grayscale(100%);
}
.prices {
  font-size: 1.5em !important;
  font-weight: 600;
}
.faces-icon {
  color: #9a9fbf;
  fill: #9a9fbf;
}
.item-value {
  color: #ff5e3a;
  position: absolute !important;
  font-size: 20px;
  width: 100px;
}

.interested {
  display: contents;
}
.interestedVisit {
  right: unset;
  max-height: 400px;
  display: inline-flex;
}
</style>
<style lang="scss">
.time-stamp {
  color: #888da8;
  font-weight: 400;
  margin-bottom: 0 !important;
}
.trade-btn {
  display: inline-block;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  border: 1px solid transparent;
  padding: 0.5rem;
  font-size: 0.688rem;
  border-radius: 0.25rem;
  transition: all 180ms ease-in-out;
  background-color: #47db86;
  color: #ffffff;
  fill: #ffffff;

  &:hover,
  &:focus {
    background-color: rgba($color: #47db86, $alpha: 0.87);
    opacity: 0.9;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}
.item-details {
  display: inline-flex;
}
.cash-price {
  color: green;
  font-size: 20px;
  font-weight: bold;
}
.points-price {
  color: blue;
  font-size: 20px;
  font-weight: bold;
}
.item-category {
  border: 2px solid #ccc;
}
.pencil-bg {
  background-color: #4c8fc5;
  color: #fff;
}
.pencil-icon {
  color: #ffffff;
  fill: #ffffff;
}

.free-price {
  color: white;
  background-color: green;
  border-radius: 2px;
  padding: 5px;
}

.border-color {
  width: 600px;
  height: 150px;
  padding: 50px;
  border: 2px solid red;
}

.trade-button-request {
  position: relative;
}
</style>
<style lang="scss" scoped>
.hr-item {
  margin-top: -10px !important;
  border-top: 1px solid lightslategray !important;
  width: 90%;
}
.no-outline {
  &:hover,
  &:focus {
    outline: none;
  }
}
</style>

<style lang="scss" scoped>
.accept-content-modal {
  padding: 3rem 0 2rem 0;
}
.page-content {
  width: 100%;
  height: 100%;
  padding: 2.5rem 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: $light;
}
.center-content {
  width: 100%;
  min-width: 300px;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: white !important;
  border: outset;

  display: flex;
  flex-direction: column;
}

// parte importante do layout
.content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;

  .content-above {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .item-informations--wrapper {
      width: 100%;
      display: flex;
    }
  }

  .content-middle {
    width: 100%;
    height: 100%;
    min-height: 300px;

    .map-item--title {
      font-size: 24px;
      font-weight: normal;
      line-height: 36px;
      margin: 0px;
      color: rgba(0, 0, 0, 0.87);
      word-break: break-word;

      padding: 10px;
    }

    .content-middle--mapContainer {
      width: 100%;
      height: 300px;
      z-index: 0;
    }
  }

  .content-below {
    display: flex;
    flex-direction: column;

    .content-below--title {
      font-size: 24px;
      font-weight: normal;
      line-height: 36px;
      margin: 0px;
      color: rgba(0, 0, 0, 0.87);
      word-break: break-word;

      padding: 10px;
    }

    .items-may-you-like--wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding: 10px;
    }
  }
}
//fim da parte importante do layout

.info-content-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem
}

.info-content-title {
  font-size: 24px;
  font-weight: normal;
  line-height: 36px;
  margin: 0px;
  color: rgba(0, 0, 0, 0.87);
  word-break: break-word;
}

.info-content-condition {
  width: 100%;
  font-size: 14px;
  line-height: 16px;
  margin: 0px;
  color: rgba(12, 12, 12, 1);

  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.info-content-price {
  width: 100%;
  display: flex;
  align-items: center;
}

.content-price {
  display: flex;
}

.price {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 1px;
  font-weight: bold;
}

.price-image-points {
  width: 10px;
  height: 10px;
  margin-bottom: 1.5rem;
}

.main-content {
  width: 100%;
  padding: 10px;
}

.item-image-wrapper {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.info-content {
  width: 100%;
  padding: 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
}

.info-content-header {
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem
}

.info-content-divider {
  border: 1px solid rgba(196, 196, 196, 0.5);
}

.info-content-header-user {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.info-content-header-button-admin {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-content-header-button{
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-item-category {
  width: 100%;
}

.info-item-avatar {
  width: 100%;

  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.info-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-username {
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-date {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: rgba(0, 0, 0, 0.6);
}

.info-item-date{
  width: 100%;
  visibility: hidden;
  display: none;
}

.item-category-title {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
}

.main-content-wrap {
  margin-bottom: 10px !important;
}

.or-option {
  font-weight: normal !important;
}
.profile-poster-link {
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87) !important
}
.profile-poster-username {
  font-size: 12px;
  color: rgba(18, 18, 18, 0.5);
}

.link-tertiary {
  color: $tertiary !important;
}
.link-offer {
  color: $offer !important;
}

.points-option {
  font-weight: bold;
  color: $primary;
  font-size: 24px;
}

.points-option {
  display: flex;
}
.request-btn-size {
  width: 90%;
}
.chat-btn-size {
  width: 10%;
  display: flex;
  justify-content: flex-end;
}
.border-image-unavailable {
  margin-top: 0 !important;
  border: 3px solid $dark;
  box-sizing: border-box;
}
.border-image-tertiary {
  margin-top: 0 !important;
  border: 3px solid $tertiary;
  box-sizing: border-box;
}
.border-image-offer {
  margin-top: 0 !important;
  border: 3px solid $offer;
  box-sizing: border-box;
}
.item-trade-type {
  width: 100%;
  height: 40px;
  color: $white;
  text-transform: uppercase;

  display: flex;
  justify-content: center;
  align-items: center;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}

.main-img {
  padding: 10px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: cover;
}

.item-trade-type-text {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.trade-type-tertiary {
  background-color: $tertiary;
}
.trade-type-offer {
  background-color: $offer;
}
.background-item-unavailable {
  background-color: $dark;
  filter: grayscale(100%);
}
.info-content-description {
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0.25px;

  height: 100%;
  max-height: 200px;
  overflow: auto;
  margin-bottom: 0px;
}

.interested-item-btn {
  border-radius: 4px;
  min-width: 20px;
}
.interested-content,
.user-item-actions {
  display: flex;
  justify-content: center;
}
.trade-item-btn {
  border-radius: 5px !important;
  width: 100%;
  height: 40px;
}
.offer-item-class .button-content i {
  margin-right: 0.5rem;
}
.offer-item-class .button-content span {
  margin-right: 1rem;
}
.send-msg-item-btn {
  min-width: 35px !important;
}
.user-item-actions {
  align-items: center;
}

::-webkit-scrollbar-thumb {
  background: #757575;
}
::-webkit-scrollbar-track {
  background: #e1e1e1;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar:horizontal{
  display: none;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track-piece {
  width: 8px;
}
.scroll {
  display: block;
  width: 100%;
  overflow: scroll;
  height: 100%;
}
@media only screen and (min-width: 768px) {
    .center-content {
        max-width: 600px;
    }
}

@media only screen and (min-width: 1024px) {
    .center-content {
      max-height: 100%;
      max-width: 900px;
    }

    .content-wrapper {
      flex-direction: column;

      .content-above {
        flex-direction: row;

        .image-of-item{
          width: 60%
        }
      }

      .content-below {
        .items-may-you-like--wrapper {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 10px;
          padding: 10px;
        }
      }
    }

    .info-content {
      justify-content: space-between;
    }

    .info-content-description {
      max-height: 350px;
    }

}

@media (min-width: 1440px) {
    .center-content{
        max-width: 1400px;
    }

    .main-img {
      padding: 0 25px
    }

    .content-wrapper {
      .content-below {
        .items-may-you-like--wrapper {
          grid-template-columns: repeat(4, 1fr);
        }
      }

    }
}
</style>

<style lang="scss">
.interested-item-btn {
  span {
    font-size: 14px;
  }
}
</style>
